/** Форма приходной накладной — UI 1:1 с Excel «Складской учет 20». */
import { DocumentForm } from "@/components/warehouse/DocumentForm";

export function WarehouseInflowFormPage() {
  return <DocumentForm direction="inflow" />;
}
